module.exports = __webpack_public_path__ + "static/media/Her World.4b83a6c1.jpg";